import React from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { imageProvider } from 'utils/imageProvider';
import { Card } from '@daedalus/atlas/Card';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import useImageErrorHandler from '@daedalus/core/src/_web/analytics/hooks/useImageErrorHandler';
import { Page } from '@daedalus/core/src/analytics/types/Events';
import { getIsRtlLanguage } from '@daedalus/core/src/auth/modules/selectors';
import { Room } from '@daedalus/core/src/room/types/room';
import { SwipeGallery } from '@daedalus/shared/src/accommodation/SwipeGallery';
import { RoomDetailsMountComponent } from './constants';
import { useTrackRoomGallerySwipe } from './useTrackRoomGallerySwipe';
type PropsTypes = {
  room: Room;
  onOpenRoomDetailsOverlay: () => void;
};
const GalleryWrapper = /*#__PURE__*/styled('div')({
  name: "GalleryWrapper",
  class: "gurumpm",
  propsAsIs: false
});
export const RoomCardGallery = ({
  room,
  onOpenRoomDetailsOverlay
}: PropsTypes) => {
  const roomImages = room.images.map(image => image.url);
  const isRtl = useSelector(getIsRtlLanguage);
  const {
    isMobile
  } = useDeviceLayout();
  const trackGallerySwipe = useTrackRoomGallerySwipe({
    room,
    component: RoomDetailsMountComponent.HotelViewRoomsSection
  });
  const handleImageError = useImageErrorHandler(room.id, Page.Accommodation);
  if (!roomImages.length) {
    return null;
  }
  return <Card borderRadius={isMobile ? 'none' : 'lg'}>
      <GalleryWrapper className={cx(isMobile && '__isMobile')} onClick={onOpenRoomDetailsOverlay}>
        <SwipeGallery showPageNumber onSwipe={trackGallerySwipe} images={roomImages} imageProvider={imageProvider} hasDarkBackground={true} hasDarkGradient={false} backgroundSize="cover" isZoomEnabled={false} isRtl={isRtl} handleImageError={handleImageError} showPaginationButtons={!isMobile} showPaginationOnHover />
      </GalleryWrapper>
    </Card>;
};

require("./RoomCardGallery.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomCardGallery.tsx");